// Tests: src/app/migrations/migrations.spec.ts
import { MigrationDefinition } from './migration.types';

/**
 * Migration: V11 → V12
 *
 * Vereinfachter und „kein"-Workflow wurden entfernt — es gibt nur noch den
 * vollen Workflow. Punkte, die in der DB ohne `workflow`-Block liegen
 * (typischerweise aus alten 'none'-Projekten), bekommen einen Workflow-
 * Block mit Status `abgeschlossen`. Damit bleibt die bisherige Sichtbarkeit
 * (Bestandsdaten wurden de-facto als abgeschlossen behandelt) erhalten und
 * der Punkt ist im neuen Modell auswertbar.
 *
 * `header.projects[0]` wird best effort als `workflow.projectId` übernommen,
 * damit das Frozen-Lock-Verhalten konsistent bleibt.
 *
 * Downgrade: workflow-Block wird wieder entfernt — die Punkte verhalten
 * sich anschließend wieder wie Bestandsdaten ohne Workflow.
 */
export const migrationV11ToV12: MigrationDefinition = {
  fromVersion: 11,
  toVersion: 12,

  upgrade(doc: any): any {
    if (!doc.workflow) {
      const projectId = doc.header?.projects?.[0]?.id;
      const now = Date.now();
      doc.workflow = {
        status: 'abgeschlossen',
        lastStatusChange: { time: now, user: 'system' },
        createdBy: { id: 'system', time: now },
        // Marker, damit die UI den Punkt weiter als „Bestand" anzeigt — die
        // Migration setzt `status='abgeschlossen'` nur, um die alte
        // Sichtbarkeit zu erhalten; semantisch ist der Punkt Bestand.
        assumedFromBestand: { time: now, user: 'system' },
        ...(projectId ? { projectId } : {}),
        history: [
          { kind: 'transition', from: null, to: 'abgeschlossen', time: now, user: 'system' }
        ]
      };
    }
    doc.version = 12;
    return doc;
  },

  downgrade(doc: any): any {
    delete doc.workflow;
    doc.version = 11;
    return doc;
  },

  dataLossWarnings: [
    'Beim Downgrade wird workflow-Block entfernt (Status, Historie gehen verloren)'
  ]
};
